import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import styles from "../../css/styles.css";
import SuggestionList from "../SuggestionList/index.js";
import GoogleEstablishmentShape from "../../shapes/GoogleEstablishmentShape.js";
import Suggestion from "../GoogleSuggestion/index.js";

var GoogleSuggestionList = function GoogleSuggestionList(props) {
  return React.createElement("div", null, React.createElement(SuggestionList, _extends({}, props, {
    Suggestion: Suggestion
  })), React.createElement("div", {
    className: styles['powered-by-google']
  }, React.createElement("img", {
    alt: "Powered By Google",
    src: "https://media.xogrp.com/images/4aeeb676-975b-4af5-96b0-18f5a8588783"
  })));
};

process.env.NODE_ENV !== "production" ? GoogleSuggestionList.propTypes = {
  suggestions: PropTypes.arrayOf(PropTypes.shape(GoogleEstablishmentShape))
} : void 0;
export default GoogleSuggestionList;